
import { useState } from 'react';

interface SubNavItem {
  label: string;
  href: string;
  isActive?: boolean;
}

interface SubNavigationProps {
  items: SubNavItem[];
}

export default function SubNavigation({ items }: SubNavigationProps) {
  const [activeTab, setActiveTab] = useState(
    items.findIndex(item => item.isActive) || 0
  );

  const handleTabClick = (index: number, href: string) => {
    setActiveTab(index);
    window.REACT_APP_NAVIGATE(href);
  };

  return (
    <div className="bg-gradient-to-b from-white to-[#fafafa] border-b border-[#e5e5e5] sticky top-[var(--header-h)] z-40 shadow-lg">
      <div className="max-w-7xl mx-auto px-4">
        <nav className="flex flex-wrap relative">
          {/* アクティブタブのアンダーライン */}
          <div 
            className="absolute bottom-0 h-1 bg-gradient-to-r from-[#d4af37] via-[#ffd700] to-[#d4af37] transition-all duration-500 ease-out rounded-t-full shadow-lg"
            style={{
              left: `${(activeTab * 100) / items.length}%`,
              width: `${100 / items.length}%`,
            }}
          />
          
          {items.map((item, index) => (
            <button
              key={index}
              className={`flex-1 px-8 py-6 text-[15px] font-semibold transition-all duration-400 cursor-pointer whitespace-nowrap relative group ${
                index === activeTab
                  ? 'text-[#1a2942] bg-gradient-to-b from-transparent via-[#f8f6f0]/40 to-[#f8f6f0]/60 shadow-inner'
                  : 'text-gray-600 hover:text-[#1a2942] hover:bg-gradient-to-b hover:from-transparent hover:via-[#f8f6f0]/20 hover:to-[#f8f6f0]/30'
              }`}
              onClick={() => handleTabClick(index, item.href)}
              style={{fontFamily: '"Playfair Display", "Noto Serif JP", serif'}}
            >
              {/* ホバー時のアンダーライン */}
              <div className={`absolute bottom-0 left-1/2 transform -translate-x-1/2 h-0.5 bg-gradient-to-r from-transparent via-[#d4af37] to-transparent transition-all duration-400 ${
                index === activeTab ? 'w-0' : 'w-0 group-hover:w-4/5'
              }`} />
              
              {/* テキスト */}
              <span className="relative z-10 tracking-wide">
                {item.label}
              </span>
              
              {/* アクティブ時の装飾 */}
              {index === activeTab && (
                <>
                  <div className="absolute -top-1 right-3 w-2 h-2 bg-gradient-to-br from-[#d4af37] to-[#b8860b] rounded-full animate-pulse shadow-md" />
                  <div className="absolute top-1/2 left-2 transform -translate-y-1/2 w-1 h-8 bg-gradient-to-b from-[#d4af37] to-[#b8860b] rounded-full opacity-30" />
                </>
              )}
              
              {/* ホバー時の光沢効果 */}
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-lg" />
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
}
